<section class="transaction-overview">
    <h3 class="section-heading">Transaction Overview</h3>
    <div class="section-grid">
        <div>
            <span class="field-label">Practice Name</span>
            <p class="field-value">{{ details.subMerchantName }}</p>
        </div>
        <div>
            <span class="field-label">Practice ID</span>
            <p class="field-value">{{ details.subMerchantId }}</p>
        </div>
        <div>
            <span class="field-label">Consumer Name</span>
            <p class="field-value">{{ details.accountHolderName }}</p>
        </div>

        <div>
            <span class="field-label">Transaction Date</span>
            <p class="field-value">
                {{ details.transactionDate | date: "MM/dd/yyyy" }}
            </p>
        </div>
        <div>
            <span class="field-label">Transaction Type</span>
            <p class="field-value">{{ details.transactionType }}</p>
        </div>
        <div>
            <span class="field-label">Transaction Amount</span>
            <p class="field-value">{{ details.amount | negativeCurrency }}</p>
        </div>

        @if (showRefundedAmount) {
            <div>
                <span class="field-label">Refunded Amount</span>
                <p class="field-value" [class.field-value--refunded]="refundedAmount !== null">
                    {{
                        refundedAmount !== null
                            ? (refundedAmount | negativeCurrency)
                            : "—"
                    }}
                </p>
            </div>
        }

        <div>
            <span class="field-label">Transaction Status</span>
            <p><ach-status-badge [status]="details.status" /></p>
        </div>
        <div>
            <span class="field-label">Processor Transaction ID</span>
            <p class="field-value">{{ details.processorTransactionId }}</p>
        </div>
        <div>
            <span class="field-label">Submitted By</span>
            <p class="field-value">{{ details.submittedBy }}</p>
        </div>

        <div>
            <span class="field-label">Product</span>
            <p class="field-value">{{ details.product }}</p>
        </div>
        <div>
            <span class="field-label">Origin Type</span>
            <p class="field-value">{{ originTypeLabel }}</p>
        </div>
        <div>
            <span class="field-label">Bank Account Type</span>
            <p class="field-value">{{ details.bankAccountType }}</p>
        </div>

        <div>
            <span class="field-label">Bank Account Number</span>
            <p class="field-value">{{ details.maskedAccountNumber }}</p>
        </div>
        <div>
            <span class="field-label">Routing Number</span>
            <p class="field-value">{{ details.routingNumber }}</p>
        </div>
        <div>
            <span class="field-label">Settlement Date</span>
            <p class="field-value">
                {{
                    details.settlementDate
                        ? (details.settlementDate | date: "MM/dd/yyyy")
                        : "—"
                }}
            </p>
        </div>
    </div>
</section>
